import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ComplaintFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import ComplaintFormStepOne from "./ComplaintFormSteps/ComplaintFormStepOne";
import ComplaintFormStepTwo from "./ComplaintFormSteps/ComplaintFormStepTwo";

const ComplaintForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues:_initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
       ..._initialValues,
       complaintType:_initialValues?.complaintType?.uuid ? {value:_initialValues?.complaintType?.uuid} : null,
       detectedInTime:_initialValues?.detectedInTime?.uuid ? {value:_initialValues?.detectedInTime?.uuid} : null,
      });
      return;
    }

    setInitialValues({
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="CarForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ComplaintFormStepOne {...formProps} {...props} />
              <ComplaintFormStepTwo />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ComplaintForm;
